import makeActionCreator from 'src/lib/makeActionCreator';

export const SET_SELECTED_PRESET = 'SET_SELECTED_PRESET';
export const SET_DEFAULT_PRESET = 'SET_DEFAULT_PRESET';

export const setSelectedPresets = makeActionCreator(SET_SELECTED_PRESET);
export const setDefaultPresets = makeActionCreator(SET_DEFAULT_PRESET);
